<template>
  <b-form-group
    label="Menü Görünümü"
    label-for="menu_view_mode"
  >
    <validation-provider
      #default="{ errors }"
      name="Menü Görünümü"
      rules="required"
    >
      <v-select
        id="menu_view_mode"
        v-model="dataItem.menu_view_mode"
        label="title"
        :options="menuViewModes"
        :reduce="view => view.id"
        placeholder="Seçiniz"
        :disabled="userData.packageLimits[24].limit < 1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'MenuViewSelectConfigsCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
      userData: JSON.parse(localStorage.getItem('userData')),
      menuViewModes: [
        {
          id: 'grid',
          title: 'Izgara',
        },
        {
          id: 'list',
          title: 'Liste',
        },
      ],
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['configs/dataItem']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>

<style scoped></style>
